import { useAuth } from "./AuthorizationFetch";
import React, { useState, useCallback } from 'react'; // Import useCallback

export const useUserProfile = () => {
    const { authenticatedFetch } = useAuth();
    const [roleType, setRoleType] = useState(null);
  
    const getUserProfile = useCallback(async () => { // Wrap with useCallback
      try {
        const response = await authenticatedFetch(`${process.env.REACT_APP_BASE_URL}/users/profile`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        
        if (!response.ok) {
          throw new Error('Failed to fetch user profile');
        }
        
        const userData = await response.json();
        setRoleType(userData.roleType);
        console.log('User roleType:', userData.roleType);
        return userData;
      } catch (error) {
        console.error('Error fetching user profile:', error);
        throw error;
      }
    }, [authenticatedFetch]); // Add authenticatedFetch as a dependency. setRoleType is stable.
  
    return { getUserProfile, roleType };
  };